// Enums are dictionary of names versus numbers. This is so they work in the same way as C# enums (and other languages) which allow multiple names to have the same number.

let cardColorEnum = {
    'white': 0,
    '#F0A7A9': 1,
    '#93D092': 2,
    '#FDCD86': 3,
    '#839EDF': 4,
    '#CBB5DD': 5,
    '#FFC6F7': 6,
    '#FFFF91': 7
};

export default cardColorEnum;
